import React from 'react';

function HomePage() {
  return (
    <>
      {/* Section Hero */}
      <section className="hero">
        <div className="container hero-content">
          <h1>Formez-vous pour un avenir durable en agriculture</h1>
          <p>
            Des formateurs passionnés et des étudiants engagés pour révolutionner l'agriculture de demain.
          </p>
          <div className="ad-phrases">
            <p>Excellence en formation agricole</p>
            <p>Innovation et savoir-faire au service de la terre</p>
            <p>Apprenez avec les meilleurs pour cultiver votre succès</p>
          </div>
          <a href="/formations" className="btn btn-primary">
            Découvrez nos formations
          </a>
        </div>
      </section>

      {/* Section Features affichant trois cartes horizontalement */}
      <section className="features container">
        <div className="feature-item">
          <img src="/image1.jpg" alt="Technologies de pointe" />
          <h2>Technologies de pointe</h2>
          <p>
            Intégrez les innovations agricoles pour une production optimisée et respectueuse de l'environnement.
          </p>
        </div>
        <div className="feature-item">
          <img src="/image2.jpg" alt="Formateurs experts" />
          <h2>Formateurs experts</h2>
          <p>
            Nos experts passionnés vous accompagnent vers l'excellence professionnelle en agriculture.
          </p>
        </div>
        <div className="feature-item">
          <img src="/image3.jpg" alt="Engagement étudiant" />
          <h2>Engagement étudiant</h2>
          <p>
            Des étudiants motivés, prêts à transformer l'agriculture grâce à une formation de qualité.
          </p>
        </div>
      </section>
    </>
  );
}

export default HomePage;
